import React from "react";
import { Hero } from "../components/Hero";
import { Services } from "../components/Services";
import { Produits } from "../components/Produits";
import { Methode } from "../components/Methode";
import { Expertise } from "../components/Expertise";
import { Formations } from "../components/Formations";
import { Faq } from "../components/Faq";
import { CallToAction } from "../components/CallToAction";
import { Contact } from "../components/Contact";

export const Accueil = () => (
  <>
    <Hero />
    <Services />
    <Produits />
    <Methode />
    <Expertise />
    <Formations />
    <Faq />
    <CallToAction />
    <Contact />
  </>
);
